import { useState, useEffect } from 'react';

// Configuración
import config from '../config';

// Socket
import Sockette from 'sockette';

const socketConfig = { timeout: 5e3, maxAttempts: 2 };

const useSocket = (roomId) => {
  const [socketActivo, setSocketActivo] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    let webSocket = null;
    if (roomId !== undefined && socketActivo === false) {
      webSocket = new Sockette(config.WebSocketUrl, {
        ...socketConfig,
        onopen: () => onOpen(webSocket),
        onclose: () => onClose(webSocket),
        onerror: onError,
        onmessage: onMessage,
      });
    }

    return () => {
      webSocket?.close();
    };
    
  }, [roomId]);

  const onOpen = (webSocket) => {
    if (webSocket !== null) {
      webSocket?.send(JSON.stringify({ action: 'enterRoom', data: roomId }));
      setSocketActivo(true);
    }
  };

  const onClose = (webSocket) => {
    setSocketActivo(false);
    webSocket.open();
  };

  const onError = (error) => {
    if (error) {
      console.error(`Error: ${JSON.stringify(error)}`);
    }
  };

  const onMessage = ({ data }) => {
    setMensaje(data);
  };

  return {
    webSocketActivo: setSocketActivo,
    mensaje: mensaje,
    setMensaje: setMensaje,
  };
};

export default useSocket;
